import { useContext, useEffect, useState } from "react";
import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";
import { BranchRead, ToolUser } from "../../../../global/API";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { removeDuplicates } from "../../../../../../core/validator/Validator";
import { Thead } from "./Thead";
import { Tbody } from "./Tbody";

export const Index = () => {
    const { tool_state, setup_state, report_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { branchData, toolUser } = setup_state;
    const { form, generateForm, salesBranchData, salesBranchList } = report_state;
    const [open, setOpen] = useState(false);
    const inputChangeHandler = async (e, val, key) => {
        const name = key === "branch_id" || key === "user_id" ? key : e.target.name;
        const value = key === "branch_id" || key === "user_id" ? (val === null ? 0 : val.id) : e.target.value;
        form.set({ ...form.data, [name]: value });
        salesBranchData.set([]);
        generateForm.set((prev) => ({ ...prev, infiniteLoad: false, offset: 0 }));
    };
    const __init = async () => {
        const res = await BranchRead(__SESSION.data.uaccess[0].company_id, "active");
        if (res) branchData.set([{ id: 0, name: "All", code: "000", active: 1 }, ...res]);
        const res_user = await ToolUser(__SESSION.data.uaccess[0].company_id);
        const data = res_user.users.filter((v) => v.active === 1);
        const uniqueData = removeDuplicates(data);
        if (res_user) toolUser.set([{ id: 0, first_name: "All", last_name: "", active: 1 }, ...uniqueData]);
    };
    useEffect(() => {
        __init();
    }, []);
    return (
        <>
            <Thead inputChangeHandler={inputChangeHandler} open={open} setOpen={setOpen} />
            <Tbody salesBranchList={salesBranchList.data} generateForm={generateForm.data} />
            <Backdrop open={generateForm.data.infiniteLoad} sx={{ zIndex: "1300" }}>
                <Box height="150px" width="100%" display="flex" alignItems="center" justifyContent="center">
                    <Box height="100%" width="270px" borderRadius="12px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                        <Stack sx={{ color: "grey.300" }} spacing={2} direction="row">
                            <CircularProgress color="inherit" />
                        </Stack>
                        <Box color="#fff">Fetching data ...</Box>
                    </Box>
                </Box>
            </Backdrop>
        </>
    );
};
